import React from "react";
import Select from "react-select";

/**
 * Dropdown buscable reutilizable sobre react-select.
 *
 * Uso pensado para listas largas (cuentas contables, clientes, etc.).
 *
 * Props:
 *  - options: [{ value, label }]
 *  - value: string (value seleccionado)
 *  - onChange: (value) => void   (recibe el value, "" si se limpia)
 *  - placeholder, isDisabled, isClearable
 *
 * Se abre en un portal a document.body (menuPosition fixed) para no quedar
 * recortado dentro de cards/tablas, igual que el resto de selects del proyecto.
 */
const portalStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 4000 }),
  control: (base) => ({ ...base, minHeight: 38 }),
};

const SearchSelect = ({
  options = [],
  value,
  onChange,
  placeholder = "Seleccionar...",
  isDisabled = false,
  isClearable = true,
  isLoading = false,
}) => {
  const selected = options.find((o) => String(o.value) === String(value ?? "")) || null;
  return (
    <Select
      classNamePrefix="react-select"
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : "")}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isLoading={isLoading}
      isSearchable
      menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
      menuPosition="fixed"
      styles={portalStyles}
      noOptionsMessage={() => "Sin resultados"}
      loadingMessage={() => "Cargando..."}
    />
  );
};

export default SearchSelect;
